import { registerSW } from 'virtual:pwa-register'

async function checkForServiceWorkerUpdate(
  swUrl: string,
  registration: ServiceWorkerRegistration | undefined,
): Promise<void> {
  if (!registration || registration.installing) return
  if (!navigator.onLine) return

  try {
    const resp = await fetch(swUrl, {
      cache: 'no-store',
      headers: {
        cache: 'no-store',
        'cache-control': 'no-cache',
      },
    })
    if (resp.status === 200) {
      await registration.update()
    }
  } catch {
    // Server unreachable — keep the current version
  }
}

let swUrl = '/sw.js'
let registration: ServiceWorkerRegistration | undefined

registerSW({
  immediate: true,
  onRegisteredSW(url, reg) {
    swUrl = url
    registration = reg
    void checkForServiceWorkerUpdate(swUrl, registration)
  },
})

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    void checkForServiceWorkerUpdate(swUrl, registration)
  }
})
